<template>
  <div>
    <sidebar-menu
      class="sidebar-style overflow-y-auto"
      :menu="menu"
      :relative="true"
      :hideToggle="true"
      :collapsed="$store.state.sidebarv2Collapse"
      @toggle-collapse="onToggleCollapse"
      :showOneChild="true"
      :showChild="$store.state.showChildRsSidebar"
      @item-click="onItemClick"
    >
      <span
        class="text-center"
        style="color: white; padding: 11px 0px;"
        slot="header"
      >
        <!-- <font-awesome-icon class="fa-2x" icon="home" /> -->
        <logoSheild v-if="$store.state.sidebarv2Collapse" :logoProps="logo" />
        <Logo v-else :logoProps="logo" />
        <hr style="background-color: #adadad;" />
      </span>
      <!-- :showOneChild="showOneChild" -->
      <span slot="dropdown-icon">
        <font-awesome-icon icon="caret-down" />
      </span>
      <span slot="toggle-icon">
        <font-awesome-icon icon="caret-up" />
      </span>
    </sidebar-menu>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import logoSheild from "../logo/logoSheild.vue";
import Logo from "../logo/transparentLogo1.vue";

export default {
  name: "SidebarRemingtonSeeds",
  components: {
    logoSheild,
    Logo,
  },
  props: {},
  created() {
    EventBus.$on("ToggleCollapse", (data) => {
      this.onToggleCollapse();
    });
    EventBus.$on("onUpdateSidebarCount", (data) => {
      this.refreshSidebarCount(data);
    });
  },
  data() {
    return {
      userType: null,

      logo: {
        width: "auto",
        height: "35px",
      },
      menu: [],
      sidebarCountAction:null,
    };
  },
  mounted() {
    this.userType = localStorage.getItem("userType");
    this.hideShowSideBarMenu();
    this.showSideBarMenuItem();
  },
  methods: {
    refreshSidebarCount(data){
      this.sidebarCountAction = data
      this.showSideBarMenuItem()
    },
    onItemClick(event, item) {
      if (item.title != "Forms") {
        this.$store.state.showChildRsSidebar = false;
      }
    },
    onToggleCollapse() {
      this.$store.state.sidebarv2Collapse =
        !this.$store.state.sidebarv2Collapse;
    },
    // to show sidebar items menu dynamically
    showSideBarMenuItem() {
      let items = JSON.parse(localStorage.getItem("sideBarItems"));
      let pendingActionsCount = JSON.parse(localStorage.getItem("pendingActionsCount"));
      // usertype admin == 2 ,superadmin 1
      if (this.userType == 1) {
        this.menu = [
          // {
          //   title: "Dashboard",
          //   href: "/dashboard",
          //   icon: "fa fa-home",
          //   hidden: false,
          // },
          // {
          //   title: "Manage Employee",
          //   href: "/manage-employee",
          //   hidden: false,
          //   icon: "fa fa-users",
          // },
          {
            title: "Manage Employee",
            icon: "fa fa-users",
            href: "/goverance/one",
            hidden: false,
          },
          {
            title: "Heath And Safety",
            icon: "fa fa-exclamation",
            href: "/goverance/health_and_safety",
            hidden: false,
          },
          {
            title: "Tasks",
            icon: "fa fa-thumbtack",
            href: "/tasks",
            hidden: true,
          },
          {
            title: "Approval List" + " " + `(${this.sidebarCountAction ? this.sidebarCountAction[0].count : pendingActionsCount[0].count})`,
            icon: "fa fa-gift",
            href: "/employee-approval-list",
            hidden: false,
          },
          // {
          //   title: "Complaints" + " " + `(${pendingActionsCount[1].count})`,
          //   icon: "fa fa-balance-scale",
          //   href: "/complaints-dashboard",
          //   hidden: false,
          // },
          {
            title: "Complaints" + " " + `(${this.sidebarCountAction ? this.sidebarCountAction[1].count : pendingActionsCount[1].count})`,
            icon: "fa fa-balance-scale",
            href: "/complaints-dashboard",
            hidden: false,
          },
          {
            title: "Settings",
            icon: "fa fa-cog",
            hidden: false,
            child: [
              {
                title: "General Settings",
                hidden: false,
                child: [
                  {
                    href: "/approval-type",
                    title: "Approval Type",
                    hidden: false,
                  },
                  {
                    href: "/departments",
                    title: "Division/Business Unit",
                    hidden: false,
                  },
                  {
                    href: "/email-tags",
                    title: "Email Tags",
                    hidden: false,
                  },
                ],
              },
              {
                title: "Platform",
                href: "/platform-settings",
                hidden: false,
              },
              {
                title: "Workflows",
                hidden: false,
                child: [
                  {
                    href: "/workflows-hr",
                    title: "Human Resources",
                  },
                  // {
                  //   href: "/workflows-it",
                  //   title: "IT",
                  // },
                ],
              },
              {
                title: "User Preferences",
                href: "/user-prefrences",
                hidden: false,
              },
              {
                title: "Forms",
                hidden: false,
                child: [
                  {
                    href: "/employee-onboarding",
                    title: "All Forms",
                  },
                ],
              },
              {
                title: "Forms Settings",
                hidden: false,
                child: [
                  {
                    href: "/onboarding",
                    title: "Client Forms",
                  },
                  // {
                  //   href: "/workflows-it",
                  //   title: "IT",
                  // },
                ],
              },
              // {
              //   href: "/custom-fields",
              //   title: "Custom Fields",
              // },
              // {
              //   href: "/styling",
              //   title: "Styling",
              // },
              // {
              //   href: "/access-control",
              //   title: "Access Control",
              // },
            ],
          },
        ];
      } else if (this.userType == 2 && items.length != 0) {
        // console.log(items,"items")
        if(this.sidebarCountAction){
          items.map(item=>{
            // if change in complaint or approval action
          this.sidebarCountAction.map(countItem =>{
            if(item.title == countItem.title){
              item.title = item.title + " " + `(${countItem.count})`;
            }
          })
        })
        }else{
          // for first time afer loggin set count
          items.map(item=>{
          pendingActionsCount.map(countItem =>{
            if(item.title == countItem.title){
              item.title = item.title + " " + `(${countItem.count})`;
            }
          })
        })
        }
        
        this.menu = items;
      } else if (this.userType == 2 && items.length == 0) {
        this.menu = [
          {
            title: "Manage Employee",
            icon: "fa fa-users",
            href: "/goverance/one",
            hidden: false,
          },
          {
            title: "Heath And Safety",
            icon: "fa fa-exclamation",
            href: "/goverance/health_and_safety",
            hidden: false,
          },
          // {
          //   title: "Tasks",
          //   icon: "fa fa-thumbtack",
          //   href: "/tasks",
          //   hidden: true,
          // },
          {
            title: "Approval List" + " " + `(${pendingActionsCount[0].count})`,
            icon: "fa fa-gift",
            href: "/employee-approval-list",
            hidden: false,
          },
          {
            title: "Complaints"+ " " + `(${pendingActionsCount[1].count})`,
            icon: "fa fa-balance-scale",
            href: "/complaints-dashboard",
            hidden: false,
          },
        ];
      }
    },
    hideShowSideBarMenu() {
      this.menu.map((fields) => {
        if (fields.title == "Settings") {
          fields.hidden = this.userType == 1 ? false : true;
        }
        if (fields.child) {
          fields.child.map((childFields) => {
            if (childFields.title == "Platform") {
              childFields.hidden = this.userType == 3 ? true : false;
            }
            if (childFields.title == "Forms Settings") {
              childFields.hidden =
                this.userType == 1 && process.env.VUE_APP_DEVEVLOPER_ONLY == 1
                  ? true
                  : true;
            }
            if (childFields.title == "Forms") {
              childFields.hidden = this.userType == 1 ? false : true;
            }
            if (childFields.title == "General Settings") {
              childFields.child.map((secondChild) => {
                if (secondChild.title == "Email Tags") {
                  secondChild.hidden =
                    process.env.VUE_APP_DEVEVLOPER_ONLY == 1 ? false : true;
                }
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style>
@import "../../assets/styles/theme1/sidebar.css";
</style>
